(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mavren-collection-circles"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('mavren-collection-nav')) {
    customElements.define('mavren-collection-nav', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.frame = requestAnimationFrame(() => this.initialize(signal));
      }

      initialize(signal) {
        if (signal.aborted || !this.isConnected) return;
        this.track = this.querySelector('.mc-track');
        if (!this.track) return;
        this.buttons = Array.from(this.querySelectorAll('[data-step]'));
        this.interacted = false;
        this.mobile = window.matchMedia('(max-width: 749px)');
        const options = { signal };
        const passive = { signal, passive: true };
        const stopCentering = () => { this.interacted = true; };
        this.track.addEventListener('pointerdown', stopCentering, passive);
        this.track.addEventListener('touchstart', stopCentering, passive);
        this.track.addEventListener('wheel', stopCentering, passive);
        this.track.addEventListener('keydown', stopCentering, options);
        this.track.addEventListener('scroll', () => this.update(), passive);
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => {
            stopCentering();
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            const previous = this.track.style.scrollBehavior;
            if (reduceMotion) this.track.style.scrollBehavior = 'auto';
            this.track.scrollBy({
              left: Number(button.dataset.step) * this.track.clientWidth * 0.75,
              behavior: reduceMotion ? 'instant' : 'smooth'
            });
            this.track.style.scrollBehavior = previous;
          }, options);
        });
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            if (signal.aborted || !this.isConnected) return;
            this.update();
            if (!this.interacted && this.mobile.matches) this.centerCurrent();
          });
        };
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this);
        this.observer.observe(this.track);
        this.track.querySelectorAll('.mc-item').forEach((item) => this.observer.observe(item));
        window.addEventListener('resize', this.schedule, passive);
        window.addEventListener('load', this.schedule, options);
        window.addEventListener('pageshow', this.schedule, options);
        document.addEventListener('DOMContentLoaded', this.schedule, options);
        document.addEventListener('shopify:section:load', (event) => {
          if (event.target.contains(this)) {
            this.interacted = false;
            this.schedule();
          }
        }, options);
        document.fonts?.ready.then(() => {
          if (!signal.aborted) this.schedule();
        });
        this.schedule();
      }

      update() {
        if (!this.track || !this.clientWidth) return;
        const overflow = this.track.scrollWidth > this.clientWidth + 2;
        this.buttons.forEach((button) => { button.hidden = !overflow; });
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const position = rtl ? -this.track.scrollLeft : this.track.scrollLeft;
        this.buttons.forEach((button) => {
          const atStart = position <= 2;
          const atEnd = position >= max - 2;
          button.disabled = Number(button.dataset.step) < 0
            ? (rtl ? atEnd : atStart)
            : (rtl ? atStart : atEnd);
        });
      }

      centerCurrent() {
        const current = this.track.querySelector('[aria-current="page"]');
        if (!current || this.track.clientWidth <= 0) return;
        const trackRect = this.track.getBoundingClientRect();
        const itemRect = current.getBoundingClientRect();
        const delta = itemRect.left + itemRect.width / 2
          - trackRect.left - this.track.clientLeft - this.track.clientWidth / 2;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const left = Math.max(rtl ? -max : 0,
          Math.min(rtl ? 0 : max, this.track.scrollLeft + delta));
        this.track.classList.add('mc-positioning');
        this.track.scrollTo({ left, behavior: 'instant' });
        cancelAnimationFrame(this.restoreFrame);
        this.restoreFrame = requestAnimationFrame(() => {
          this.track.classList.remove('mc-positioning');
          this.update();
        });
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.restoreFrame);
        this.track?.classList.remove('mc-positioning');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
